import { Editor } from "grapesjs";

export default function BoxPlugin(editor: Editor) {
  const blockManager = editor.BlockManager;
  const domComponents = editor.DomComponents;

  domComponents.addType("box", {
    model: {
      defaults: {
        tagName: "div",
        content: "",
        attributes: {},
        style: {
          "min-height": "50px",
        },
        traits: [
          {
            type: "text",
            label: "ID",
            name: "id",
          },
          {
            type: "select",
            label: "Tag",
            name: "tagName",
            options: [
              { id: "div", value: "div", name: "Div" },
              { id: "header", value: "header", name: "Header" },
              { id: "nav", value: "nav", name: "Nav" },
              { id: "main", value: "main", name: "Main" },
              { id: "aside", value: "aside", name: "Aside" },
              { id: "section", value: "section", name: "Section" },
              { id: "article", value: "article", name: "Article" },
              { id: "footer", value: "footer", name: "Footer" },
            ],
            changeProp: true,
          },
        ],
      },
      getLabel() {
        const classList = this.getClasses();
        this.setName("Box | " + classList.join("."));
      },
    },
    view: {
      onRender() {
        // @ts-ignore
        this.model.getLabel();
      },
      onAttrUpdate() {
        // @ts-ignore
        this.model.getLabel();
      },
    },
  });

  blockManager.add("box", {
    label: "Box",
    category: "Basic",
    media: `<i class="fa-sharp fa-light fa-rectangles-mixed fs-2"></i>`,
    content: {
      type: "box",
    },
  });
}
